import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateLeadDialog from "../components/leads/CreateLeadDialog";
import "../styles/leads.css";

const API_URL = "https://crmapi.zauntrip.com/api/leads";

const PRIORITY_STYLE = {
  Hot:  { background: "#fee2e2", color: "#b91c1c" },
  Warm: { background: "#fef3c7", color: "#92400e" },
  Cold: { background: "#dbeafe", color: "#1e40af" },
};

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const navigate = useNavigate();

  useEffect(() => { loadLeads(); }, []);

  const loadLeads = async () => {
    try {
      setFetching(true);
      const res = await fetch(API_URL);
      const data = await res.json();
      setLeads(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Failed to fetch leads:", err);
      setLeads([]);
    } finally {
      setFetching(false);
    }
  };

  const handleCreateLead = async (formData) => {
    try {
      setLoading(true);
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const result = await res.json();
      if (res.ok) { setOpen(false); loadLeads(); }
      else alert(result.message || "Failed to create lead");
    } catch (err) {
      console.error(err);
      alert("Failed to create lead");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this lead?")) return;
    try {
      const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
      const result = await res.json();
      if (res.ok) loadLeads();
      else alert(result.message || "Failed to delete lead");
    } catch (err) {
      console.error(err);
      alert("Failed to delete lead");
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1>Leads</h1>
        <button className="btn-primary" onClick={() => setOpen(true)}>+ Add Lead</button>
      </div>

      <CreateLeadDialog
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleCreateLead}
        isLoading={loading}
      />

      {fetching ? (
        <div className="loading">Loading leads...</div>
      ) : leads.length === 0 ? (
        <div className="empty-state"><p>No leads found. Create your first lead!</p></div>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Lead ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Source</th>
              <th>Priority</th>
              <th>Travel Type</th>
              <th>Destination</th>
              <th>BDM</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((lead) => {
              const priorityStyle = PRIORITY_STYLE[lead.priority] || {};
              return (
                <tr key={lead._id}>
                  <td><code style={{ fontSize: 12 }}>{lead.leadId || "—"}</code></td>
                  <td>{lead.firstName} {lead.lastName}</td>
                  <td>{lead.email || "—"}</td>
                  <td>{lead.phone || "—"}</td>
                  <td><span className="source-tag">{lead.source || "—"}</span></td>
                  <td>
                    {lead.priority && (
                      <span style={{
                        ...priorityStyle,
                        padding: "2px 10px",
                        borderRadius: 12,
                        fontSize: 12,
                        fontWeight: 700,
                      }}>
                        {lead.priority}
                      </span>
                    )}
                  </td>
                  <td>{lead.travelType || "—"}</td>
                  <td>{lead.destinationName || "—"}</td>
                  <td>{lead.createdBy || "—"}</td>
                  <td className="actions">
                    <button className="btn-outline" onClick={() => navigate(`/leads/${lead._id}`)}>View</button>
                    <button className="btn-outline" onClick={() => navigate(`/leads/${lead._id}/edit`)}>Edit</button>
                    <button className="btn-danger" onClick={() => handleDelete(lead._id)}>Delete</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}